import React from 'react';
import type { ExtendedTier } from '@/types/ExtendedTier';
import { ExtendedOvertimeSection } from '../../shared/ExtendedOvertimeSection';


interface Props {
  customizedFields: Record<string, boolean>;
  context: 'user' | 'client';
  firstOvertimeMultiplierName: string;
  extendedOvertimeEnabled: boolean;
  onExtendedOvertimeEnabledChange: (enabled: boolean) => void;
  extendedOvertimeTiers: ExtendedTier[];
  onExtendedOvertimeTiersChange: (tiers: ExtendedTier[]) => void;
  highestOvertimeRate: number;
  highestOvertimeTierName?: string;
  defaultTiers?: ExtendedTier[];
  maxTiers?: number;
}

export const MultiplierOffsetSection: React.FC<Props> = ({
  customizedFields,
  context,
  extendedOvertimeEnabled,
  onExtendedOvertimeEnabledChange,
  extendedOvertimeTiers,
  onExtendedOvertimeTiersChange,
  highestOvertimeRate,
  highestOvertimeTierName,
  defaultTiers,
  maxTiers,
}) => {
  return (
    <div>
      <ExtendedOvertimeSection
          enabled={extendedOvertimeEnabled}
          onEnabledChange={onExtendedOvertimeEnabledChange}
          tiers={extendedOvertimeTiers}
          onTiersChange={onExtendedOvertimeTiersChange}
          highestOvertimeRate={highestOvertimeRate}
          highestOvertimeTierName={highestOvertimeTierName}
          context={context}
          defaultTiers={defaultTiers}
          maxTiers={maxTiers}
        />
    </div>
  );
};
